import { Button, Card } from "react-bootstrap";
import React from "react";
import { useTranslation } from "react-i18next";

interface SurveyDialogProps {
  open: boolean;
  onClose: () => void;
  onComplete: (payload: any) => void;
  onSave: (user: any) => void;
  surveyId: string;
}

function injectSurvicate(updateUserCallback: (payload: any) => void, props: SurveyDialogProps) {
  const s = document.createElement("script");
  s.src = `https://survey.survicate.com/workspaces/${
    (window as any).SURVICATE_TEMPLATE || "fc6e7179e04d76348fae46ab62291824"
  }/web_surveys.js`;

  s.onload = () => {
    const checkForSurvicateInit = setInterval(() => {
      if (!(window as any)._sva) return;
      clearInterval(checkForSurvicateInit);

      const sva = (window as any)._sva;
      if (sva) {
        sva.addEventListener("survey_completed", () => {
          updateUserCallback("true-" + props.surveyId);
        });

        sva.showSurvey(props.surveyId || "9f95d9f0d2dfac16", { forceDisplay: true });
      }
    }, 500);
  };

  s.async = true;
  const e = document.getElementsByTagName("script")[0];
  e.parentNode?.insertBefore(s, e);
}

export const SXSurveyDialog = (props: SurveyDialogProps) => {
  const { open, onClose, onComplete } = props;
  const { t } = useTranslation();
  // --- Contexts ---
  const [, updateState] = React.useState<object>();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  if (!open) return null;

  return (
    <div
      className="no-print"
      style={{
        zIndex: 9000,
        overflow: "hidden",
        position: "fixed",
        bottom: "100px",
        right: "60px",
        fontFamily: "Open sans, sans-serif",
        background: "#ecf0f1",
        boxShadow: "0 0 25px rgba(0,0,0,0.5)",
        borderRadius: "5px",
        width: "300px",
        padding: 0,
      }}
    >
      <Card>
        <Card.Header style={{ backgroundColor: "#485253", color: "white", fontWeight: "bold" }}>
          {t("survey_title_.label")}
        </Card.Header>
        <Card.Body style={{ padding: "10px 15px" }}>
          <Card.Title as="p">{t("survey_body_.label")}</Card.Title>
          <div className="d-flex">
            <Button
              variant="success"
              className="w-75 rounded-0 me-1"
              onClick={() => {
                injectSurvicate(onComplete, props);

                onClose();
              }}
            >
              {t("survey_cta_.label")}
            </Button>
            <Button variant="secondary" className="w-25 rounded-0" onClick={onClose}>
              {t("close_.label")}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};
